<template>
  <div class="body-form">
    <Loading v-if="isLoading" />
    <Popup :message="message" v-if="isPopup" @close="() => (isPopup = false)" />
    <div style="width: 90%; margin: 30px 0;">
      <div class="menus-top">
        <span class="blue-text" @click="$router.go(-1)">Testimoni</span>
        <Arrow :width="20" :height="20" direct="left" strokeColor="#7B7E8C" class="icon" />
        <span style="color: #7b7e8c">{{ name }}</span>
      </div>
      <div class="card-form-head">
        <h1>Form {{ name }}</h1>
      </div>

      <div class="tab-selector" v-if="isEdit || isWatch">
        <button
          :class="['tab', activeTab === 'id' ? 'active-tab' : '']"
          @click="activeTab = 'id'"
        >
          Bahasa Indonesia
        </button>
        <button
          :class="['tab', activeTab === 'en' ? 'active-tab' : '']"
          @click="activeTab = 'en'"
        >
          Bahasa Inggris
        </button>
      </div>

      <div v-if="activeTab === 'id'" class="language-section">
        <div class="cart-form">
          <v-card-title class="card-form-head-2">
            <h1>Bahasa Indonesia</h1>
          </v-card-title>
          <div class="mt-5">
            <div class="content-form">
              <p>Kategori</p>
              <v-select
                :disabled="isWatch"
                class="form-input"
                :items="listCategory"
                v-model="form.category"
                solo
                :item-text="'name'"
                :item-value="'value'"
                placeholder="Pilih Kategori"
              ></v-select>
            </div>
            <div class="content-form">
              <p>Nama</p>
              <v-text-field
                :disabled="isWatch"
                outlined
                v-model="form.name"
                class="form-input"
                placeholder="Masukkan Nama Lengkap"
                dense
                clearable
              ></v-text-field>
            </div>
            <div class="content-form">
              <p>Status</p>
              <div class="spacing-switch">
                <v-switch
                  v-model="form.is_active"
                  color="primary"
                  hide-details
                  style="margin-top: -5px"
                  :disabled="isWatch"
                ></v-switch>
                <div>
                  <Chip :active="form.is_active" />
                </div>
              </div>
            </div>
            <div class="content-form">
              <p>Jurusan Kuliah</p>
              <v-text-field
                :disabled="isWatch"
                outlined
                v-model="form.field_of_study"
                class="form-input"
                placeholder="Masukkan Jurusan Kuliah"
                dense
                clearable
              ></v-text-field>
            </div>
            <div class="content-form">
              <p>Posisi Pekerjaan</p>
              <v-text-field
                :disabled="isWatch"
                outlined
                v-model="form.job"
                class="form-input"
                placeholder="Tulis Posisi Pekerjaan"
                dense
                clearable
              ></v-text-field>
            </div>
            <div class="content-form">
              <p>Asal Universitas</p>
              <v-text-field
                :disabled="isWatch"
                outlined
                v-model="form.place"
                class="form-input"
                placeholder="Masukkan Asal Universitas"
                dense
                clearable
              ></v-text-field>
            </div>
            <div class="content-form">
              <p>Feedback</p>
              <v-textarea
                :disabled="isWatch"
                placeholder="Tulis masukan ...."
                outlined
                rows="3"
                v-model="form.feedback"
                clearable
                class="form-input"
              ></v-textarea>
            </div>
            <div class="content-form">
              <p>Foto Profil</p>
              <v-file-input
                v-model="img_portfolio"
                accept="image/*"
                placeholder="Unggah Berkas Gambar"
                class="form-upload"
                prepend-icon=""
                outlined
                :disabled="isWatch"
              >
                <template
                  v-slot:prepend-inner
                  v-if="isEdit && img_portfolio == null"
                >
                  <ImageModal
                    :src="form.image_url"
                    width="76.31"
                    height="37"
                    radius="3"
                  />
                </template>
                <template v-slot:append>
                  <h5 style="margin-top: 15%; color: #2d46cf">Upload</h5>
                </template>
              </v-file-input>
              <p class="note-file">
                *Rekomendasi dimensi 500 x 500 px. ukuran file maks 1 MB
              </p>
            </div>
          </div>
        </div>
      </div>

      <div v-if="activeTab === 'en'" class="language-section">
        <div class="cart-form">
          <v-card-title class="card-form-head-2">
            <h1>Bahasa Inggris</h1>
          </v-card-title>
          <div class="mt-5">
            <div class="content-form">
              <p>Name</p>
              <v-text-field
                :disabled="isWatch"
                outlined
                v-model="formEng.name"
                class="form-input"
                placeholder="Enter Full Name"
                dense
                clearable
              ></v-text-field>
            </div>
            <div class="content-form">
              <p>Field of Study</p>
              <v-text-field
                :disabled="isWatch"
                outlined
                v-model="formEng.field_of_study"
                class="form-input"
                placeholder="Enter Field of Study"
                dense
                clearable
              ></v-text-field>
            </div>
            <div class="content-form">
              <p>Job Position</p>
              <v-text-field
                :disabled="isWatch"
                outlined
                v-model="formEng.job"
                class="form-input"
                placeholder="Enter Job Position"
                dense
                clearable
              ></v-text-field>
            </div>
            <div class="content-form">
              <p>University</p>
              <v-text-field
                :disabled="isWatch"
                outlined
                v-model="formEng.place"
                class="form-input"
                placeholder="Enter University"
                dense
                clearable
              ></v-text-field>
            </div>
            <div class="content-form">
              <p>Feedback</p>
              <v-textarea
                :disabled="isWatch"
                placeholder="Write feedback ..."
                outlined
                rows="3"
                v-model="formEng.feedback"
                clearable
                class="form-input"
              ></v-textarea>
            </div>
          </div>
        </div>
      </div>

      <div class="submit-box" v-if="!isWatch">
        <Button
          name="Batalkan"
          outline
          class="me-3"
          @click="$router.push('/testimoni')"
        />
        <Button
          :name="isEdit ? 'Simpan' : 'Simpan & Publish'"
          :width="isEdit ? '156px' : '200px'"
          @click="onSubmit"
          :disabled="!validData"
          style="background-color: #2d46cf; color: #ffffff"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Loading from "@/components/ilustration/Loading.vue";
import Button from "../../../components/Button.vue";
import Chip from "../../../components/Chip.vue";
import ImageModal from "../../../components/ImageModal.vue";
import Popup from "@/components/others/Popup.vue";
import Arrow from "@/components/icons/Arrow.vue";

export default {
  name: "FormTestimoni",
  components: {
    Loading,
    Button,
    Chip,
    ImageModal,
    Popup,
    Arrow,
  },
  computed: {
    validData() {
      return (
        this.form.name &&
        this.form.feedback &&
        this.form.category &&
        (this.isEdit || this.img_portfolio)
      );
    },
  },
  data() {
    return {
      id: null,
      name: "",
      isLoading: false,
      isWatch: false,
      isEdit: false,
      message: "",
      isPopup: false,
      activeTab: "id",
      img_portfolio: null,
      form: {
        name: "",
        image_url: "",
        feedback: "",
        field_of_study: "",
        job: "",
        is_active: false,
        place: "",
        category: "",
      },
      formEng: {
        name: "",
        feedback: "",
        field_of_study: "",
        job: "",
        place: "",
      },
      listCategory: [
        { name: "Kampus Merdeka", value: "KAMPUS_MERDEKA" },
        { name: "Prakerja", value: "PRAKERJA" },
        { name: "Home", value: "HOME" },
        { name: "Corporate Service", value: "CORPORATE" },
        { name: "Akselerasi", value: "ACCELERATION" },
        { name: "Corporate Training", value: "TRAINING" },
        { name: "Corporate Collaboration", value: "COLLABORATION" },
        { name: "Talent as a Service", value: "TALENT_SERVICE" },
      ],
    };
  },
  methods: {
    checkingType() {
      this.name = this.$route.meta.name;
      this.isWatch = this.$route.path.lastIndexOf("watch") >= 0;
      this.isEdit = this.$route.path.lastIndexOf("edit") >= 0;
      this.id = this.$route.params.id;
      if (!this.id) return;
      this.getDataTestimoni();
    },
    async getDataTestimoni() {
      this.isLoading = true;
      try {
        const resp = await this.$crm_http.get("/v1/testimony/" + this.id);
        const data = resp.data.data.testimony;
        this.form = {
          name: data.name || "",
          image_url: data.image_url || "",
          feedback: data.feedback || "",
          field_of_study: data.field_of_study || "",
          job: data.job || "",
          is_active: data.is_active || false,
          place: data.place || "",
          category: data.category || "",
          id: data.id,
        };
        await this.getBilingual();
      } catch (err) {
        this.message = err.response?.data?.data || "Failed to load data.";
        this.isPopup = true;
      } finally {
        this.isLoading = false;
      }
    },
    async getBilingual() {
      try {
        const { data } = await this.$crm_http.get(
          `/v1/bilingual/record/${this.id}?table_name=testimony&language_code=en`
        );
        const resp = JSON.parse(data.data.bilingual?.translated_data || "{}");
        this.formEng = {
          name: resp.name || "",
          feedback: resp.feedback || "",
          field_of_study: resp.field_of_study || "",
          job: resp.job || "",
          place: resp.place || "",
        };
      } catch (err) {
        console.log(err);
      }
    },
    async onSubmit() {
      this.isLoading = true;
      try {
        let imageUrl = this.form.image_url;

        if (this.img_portfolio) {
          const imageForm = new FormData();
          imageForm.append("attachment", this.img_portfolio);
          const webRes = await this.$crm_http.post("/v1/upload-file", imageForm);
          imageUrl = webRes.data.data.upload_image_response.url_w_query;
          imageForm.delete("attachment");
        }

        const payload = {
          name: this.form.name,
          image_url: imageUrl,
          feedback: this.form.feedback,
          field_of_study: this.form.field_of_study,
          job: this.form.job,
          is_active: this.form.is_active,
          place: this.form.place,
          category: this.form.category,
        };

        if (this.isEdit) {
          await this.$crm_http.put("/v1/testimony/" + this.form.id, payload);
          await this.onSubmitBilingual(imageUrl);
        } else {
          await this.$crm_http.post("/v1/testimony", payload);
        }

        setTimeout(() => {
          this.$router.push("/testimoni");
        }, 2000);
      } catch (err) {
        this.message = err.response?.data?.data || "Failed to submit data.";
        this.isPopup = true;
        this.isLoading = false;
      }
    },
    async onSubmitBilingual(imageUrl) {
      const payload = {
        table_name: "testimony",
        record_id: this.id,
        language_code: "en",
        translated_data: JSON.stringify({
          name: this.formEng.name,
          feedback: this.formEng.feedback,
          field_of_study: this.formEng.field_of_study,
          job: this.formEng.job,
          place: this.formEng.place,
          image_url: imageUrl,
          is_active: this.form.is_active,
          category: this.form.category,
        }),
      };
      try {
        await this.$crm_http.post("/v1/bilingual", payload);
      } catch (err) {
        console.log(err);
      }
    },
  },
  mounted() {
    this.checkingType();
  },
};
</script>

<style scoped>
.menus-top {
  padding-top: 10px;
  display: flex;
  font-size: 16px;
  gap: 8px;
  align-items: center;
  margin-bottom: 10px;
}
.card-form-head {
  display: flex;
  margin: 40px 0;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 20px;
}
.card-form-head-2 {
  display: flex;
  margin-left: -35px;
  margin-right: -20px;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 20px;
  border-bottom: 1px solid gray;
}
.card-form-head-2 h1 {
  font-weight: 700;
  font-size: 18px;
  color: #36373f;
  font-family: 'Poppins', sans-serif;
  margin: 0;
}
.tab-selector {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-bottom: 50px;
}
.tab {
  padding: 10px 20px;
  border: 1px solid #ccc;
  border-radius: 8px;
  cursor: pointer;
  background-color: #f9f9f9;
}
.active-tab {
  background-color: #2d46cf;
  color: white;
  border-color: #2d46cf;
}
.body-form {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fafaf9;
  padding-bottom: 30px;
  min-height: 100vh;
}
.cart-form {
  position: relative;
  margin: 40px 0;
  border-radius: 30px;
  padding: 30px 40px;
  background-color: #ffffff;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
}
.language-section {
  margin-bottom: 30px;
}
.content-form {
  margin-top: 15px;
}
.content-form p {
  font-size: 14px;
  margin: 3px 0;
  font-weight: bold;
}
.form-input {
  border-radius: 14px !important;
  background-color: transparent !important;
}
.form-input:focus {
  border-color: #2d46cf;
  box-shadow: 0 0 5px rgba(45, 70, 207, 0.3);
}
.form-upload .v-input__slot {
  height: 62px !important;
  background-color: #ffffff !important;
}
.form-upload .v-text-field__details {
  display: none;
}
.submit-box {
  display: flex;
  justify-content: center;
  margin: 20px 0;
}
.note-file {
  font-weight: 400;
  font-size: 12px;
  color: #b80f0a;
  margin-bottom: 20px !important;
}
.spacing-switch {
  display: flex;
  align-items: center;
  gap: 10px;
}
.alert-info {
  color: #7b7e8c;
  font-size: 12px;
}
.blue-text {
  font-weight: bold;
  color: #162ca2;
  cursor: pointer;
}
</style>